import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import SwitchToggle from '../SwitchToggle';
import { triggerEvent } from '../../utils';
import { ContentEditorSection, FieldSet, FieldSetLabel } from './styles';

const EditorSettings = ({ editor, data, payload, setPayload, translations, isSession }) => {
  const { useAutoSave } = editor;
  const { privacy_level, allow_hub_creation, allow_node_movement } = data;
  const [privacyLevelStart, setPrivacyLevelStart] = useState(privacy_level === 'start');
  const [allowHubCreation, setAllowHubCreation] = useState(allow_hub_creation);
  const [allowNodeMovement, setAllowNodeMovement] = useState(allow_node_movement);

  const appTexts = translations.app;
  const dispatchEvent = (name, data) => {
    if (useAutoSave) {
      triggerEvent(name, data);
    }
  };

  useEffect(() => {
    const privacyLevel = privacyLevelStart ? 'start' : 'view';
    if (
      allow_node_movement !== allowNodeMovement ||
      allow_hub_creation !== allowHubCreation ||
      privacy_level !== privacyLevel
    ) {
      setPayload({
        ...payload,
        allow_node_movement: allowNodeMovement,
        allow_hub_creation: allowHubCreation,
        privacy_level: privacyLevel,
        immediateSave: true,
      });
    }
  }, [allowNodeMovement, allowHubCreation, privacyLevelStart]);

  useEffect(() => {
    dispatchEvent('allowHubCreation', allowHubCreation);
  }, [allowHubCreation]);

  useEffect(() => {
    dispatchEvent('allowNodeMovement', allowNodeMovement);
  }, [allowNodeMovement]);

  useEffect(() => {
    if (data.allow_node_movement !== allowNodeMovement) {
      setAllowNodeMovement(data.allow_node_movement);
    }
  }, [data.allow_node_movement]);

  useEffect(() => {
    if (data.allow_hub_creation !== allowHubCreation) {
      setAllowHubCreation(data.allow_hub_creation);
    }
  }, [data.allow_hub_creation]);

  useEffect(() => {
    const privacyLevel = privacyLevelStart ? 'start' : 'view';
    if (data.privacy_level !== privacyLevel) {
      setPrivacyLevelStart(data.privacy_level === 'start');
    }
  }, [data.privacy_level]);

  return (
    <ContentEditorSection>
      <FieldSet>
        <FieldSetLabel>{appTexts.editorSettings}</FieldSetLabel>
        <SwitchToggle
          id="allow_node_movement"
          defaultChecked={allowNodeMovement}
          onChange={() => setAllowNodeMovement(!allowNodeMovement)}
        >
          {appTexts.allow_node_movement}
        </SwitchToggle>

        <SwitchToggle
          id="allow_hub_creation"
          defaultChecked={allowHubCreation}
          onChange={() => setAllowHubCreation(!allowHubCreation)}
        >
          {appTexts.allow_hub_creation}
        </SwitchToggle>

        {!isSession && (
          <SwitchToggle
            id="privacy_level_start"
            defaultChecked={privacyLevelStart}
            onChange={() => setPrivacyLevelStart(!privacyLevelStart)}
          >
            {appTexts.shared}
          </SwitchToggle>
        )}
      </FieldSet>
    </ContentEditorSection>
  );
};

export default EditorSettings;

EditorSettings.propTypes = {
  editor: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  payload: PropTypes.object.isRequired,
  setPayload: PropTypes.func.isRequired,
  translations: PropTypes.object.isRequired,
  isSession: PropTypes.bool.isRequired,
};
